import React from 'react';
import { ILinkFunc } from '../../lib/util';
import { Button } from '../Button';
import Heading from "./Heading";

export enum EDividedBladeDirection {
  row = "row",
  column = "column"
}

export interface IFirstSectionProps {
  header?: string;
  titleHeadingLevel?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "p";
  text?: string;
}

export interface ISecondSectionProps {
  header?: string;
  titleHeadingLevel?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "p";
  text?: string;
  contentCols?: string[];
  link?: { label: string; url: string };
}

export interface IDividedBladeProps {
  className?: string;
  linkFunc?: ILinkFunc;
  direction: EDividedBladeDirection;
  firstSection: IFirstSectionProps;
  secondSection: ISecondSectionProps;
}

export const DividedBlade: React.FC<IDividedBladeProps> = ({
  className = "",
  linkFunc,
  direction,
  firstSection,
  secondSection
}) => {

  const linkf = linkFunc || ((props) => <a {...props} />);
  let containerClass = "flex-wrap md:flex-nowrap";
  let firstSectionClass = "w-full md:w-1/2 lg:w-3/5";
  let secondSectionClass = "w-full md:w-1/2 lg:w-2/5";
  let dividerClass = "md:w-px md:border-b-0 md:border-l md:self-stretch";
  let firstSectionHeaderClass = "";
  let firstSectionContentClass = "";

  if (direction == EDividedBladeDirection.column) {
    containerClass = "flex-col items-stretch";
    firstSectionClass = "items-center";
    secondSectionClass = "";
    dividerClass = "";
    firstSectionHeaderClass = "text-center";
    firstSectionContentClass = "lg:w-3/5";
  }

  return (
    <section
      className={`divided-blade ${className} ${containerClass} relative p-5 md:p-14 w-full flex gap-10 justify-center items-center`}
    >
      <div className={`flex flex-col ${firstSectionClass}`}>
        <Heading
          headingLevel={firstSection.titleHeadingLevel || "h3"}
          className={`pb-6 text-2xl ${firstSectionHeaderClass}`}
        >
          {firstSection.header}
        </Heading>

        {firstSection.text && (
          <div
            className={`${firstSectionContentClass}`}
            dangerouslySetInnerHTML={{ __html: firstSection.text }}
          ></div>
        )}
      </div>

      <div className={`border-b w-full ${dividerClass}`}></div>

      <div className={` flex flex-col items-center ${secondSectionClass}`}>
        {secondSection.header && (
          <Heading
            headingLevel={secondSection.titleHeadingLevel || "h3"}
            className="italic text-center text-2xl"
          >
            {secondSection.header}
          </Heading>
        )}

        {secondSection.text && (
          <div
            className="pb-3"
            dangerouslySetInnerHTML={{ __html: secondSection.text }}
          ></div>
        )}

        {secondSection.contentCols && secondSection.contentCols.length > 0 && (
          <div
            className={`py-6 w-full flex flex-col md:flex-row justify-evenly items-start`}
          >
            {secondSection.contentCols.map((column: string, index: number) => (
              <div dangerouslySetInnerHTML={{ __html: column }}></div>
            ))}
          </div>
        )}

        {secondSection.link && (
          <Button
            line={true}
            icon={false}
            linkProps={{
              href: secondSection.link.url,
              className: `normal-case italic font-normal`,
            }}
            linkFunc={linkf}
          >
            {secondSection.link.label}
          </Button>
        )}
      </div>
    </section>
  );
}

export default DividedBlade;